<template>
    <div class="upyield-publisher min-h-screen bg-gray-100">
        <router-view v-if="auth.isLoaded" />
        <section
            v-else
            v-loading="!auth.isLoaded"
            class="app-content-spinner min-h-screen"
        />
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import auth, { initOttAuth, initAuth, clearAuth, authLoaded } from '@/store/auth';
import EventBus from 'shared-lib/helpers/eventBus';
import router from '@/router';
export default defineComponent({
    name: 'App',

    setup () {
        // TODO fix "[Vue warn]: The setup binding property “…” is already declared." error so this catcher can be removed
        if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            const oldError = console.error;
            // eslint-disable-next-line no-console
            console.error = function (message) {
                if (message && message.startsWith && !message.startsWith('[Vue warn]: The setup binding property')) oldError.apply(console, arguments);
            };
        }

        EventBus.$on('logout', () => {
            clearAuth();
            authLoaded();
            router.push({ name: 'Login' });
        });

        // init authorization
        initOttAuth()
            .then(() => initAuth());

        return {
            auth,
        };
    },
});
</script>
